module.exports = __webpack_public_path__ + "static/exercicios-27cd000403d8e7672a648f72ea96bd89.svg";